import { mergeStyles } from '@fluentui/react';

export default () => {
  return (
    <iframe
      className={iframeStyles}
      src="https://docs.google.com/spreadsheets/d/1idoOiwmno88vbflrvkYtVTtG9n5ym6GuSt0nAfY7XPU/edit?usp=sharing"
    >
      Desteklenmiyor.
    </iframe>
  );
};

const iframeStyles = mergeStyles({
  width: "100%",
  height: "calc(100vh - 56px)",
  marginTop: "8px",
  border: "none",
  userSelect: "none",
});
